.table {
  border-radius: 12px;

  .groupRow,
  .groupRow > div {
    min-height: 55px;
    height: auto;
  }
}

.buttonSet {
  margin-right: 10px;
  text-transform: uppercase;
}

.loader {
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;

  img {
    width: 50px;
  }
}

.headerSection {
  display: flex;
  justify-content: space-between;
}

.headerText {
  font-size: 18px;
  font-weight: 500;
}

.section {
  display: grid;
  border-radius: 12px;
  grid-gap: 20px;
  padding: 20px;
  margin: 20px 0;
  @include themify($themes) {
    background-color: themed("main-secondary");
    border: 1px solid themed("neutral-secondary");
  }

  &:first-child {
    margin-top: 0;
  }

  &.form {
    grid-template-columns: 1fr 1fr;
  }
}
.input {
  padding: 0;
  input {
    font-size: 14px;
    font-weight: 400;
  }
}

.value {
  font-size: 14px;
  font-weight: 400;
  user-select: text;
}

.label {
  align-items: center;
  display: flex;
  font-weight: 500;
  font-size: 16px;
}

.editRow.label {
  margin-bottom: 12px;
}

.submitChanges {
  grid-column-start: 1;
  grid-column-end: 3;
}

.groupDetails {
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  svg {
    transform: rotate(180deg);
    cursor: pointer;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }
}

.usersTableClassName {
  border-radius: 12px;
  margin-top: 0;
}

.section.withTable {
  padding: 0;
  border: unset;
}

.addGroupModal {
  width: 450px;

  .body {
    display: flex;
    flex-direction: column;
  }

  .text {
    font-size: 14px;
    line-height: 20px;
    margin-top: 12px;
  }
}
